export const getRandomWeightedOption = (options: { deg: number; rate: number; coupon: string, couponPrompt?: string }[]) => {
  // 确保权重总和为100
  const totalWeight = options.reduce((sum, option) => sum + option.rate, 0);

  // 生成0-100之间的随机数
  const randomNum = Math.random() * totalWeight;

  // 根据权重区间确定选中项
  let weightSum = 0;
  for (const option of options) {
    weightSum += option.rate;
    if (randomNum <= weightSum) {
      return option;
    }
  }

  // 默认返回第一项（理论上不会执行到这里）
  return options[0];
};
